var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditPasswordPolicyAction(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.08325 1.24996C7.19269 1.14053 7.32261 1.05372 7.46559 0.994494C7.60857 0.935268 7.76182 0.904785 7.91659 0.904785C8.07135 0.904785 8.2246 0.935268 8.36758 0.994494C8.51057 1.05372 8.64048 1.14053 8.74992 1.24996C8.85935 1.3594 8.94616 1.48932 9.00539 1.6323C9.06461 1.77528 9.0951 1.92853 9.0951 2.0833C9.0951 2.23806 9.06461 2.39131 9.00539 2.53429C8.94616 2.67728 8.85935 2.8072 8.74992 2.91663L3.12492 8.54163L0.833252 9.16663L1.45825 6.87496L7.08325 1.24996Z",
    stroke: "#4B475C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPasswordPolicyAction);
export default __webpack_public_path__ + "static/media/edit_password_policy_action.1b6a6fc95e93fa17aeecfbc907d5549e.svg";
export { ForwardRef as ReactComponent };